import React from 'react'
import moment from 'moment'
import Link from 'next/link'
import { DescriptionOutlined } from '@mui/icons-material'
import EastIcon from '@mui/icons-material/East'
import { Box, Flex, Text } from '@fundamentals'
import { localizedStrings } from '@core/strings'
import { TimelineBlockBase } from '@common/Timeline'
import { AuditResult } from '@core/entities/audit/AuditResult'

type ComponentProps = {
  auditResult: AuditResult
}

export const TimelineComplianceEventBlock: React.FC<ComponentProps> = ({
  auditResult,
}) => {
  const title = auditResult.complianceTitle
  const expiryDate = auditResult.complianceExpiryDate
  const fileUrl = auditResult.firstAttachmentDownloadUrl
  const rejectionReason = auditResult.complianceRejectionReason

  const showApprovedDuration =
    auditResult.isComplianceApproved() && !!expiryDate
  const showExpiredEnd = auditResult.isComplianceExpired() && !!expiryDate

  if (!title) {
    return null
  }

  return (
    <>
      {!!rejectionReason && (
        <TimelineBlockBase title={localizedStrings.comment}>
          <Text variant='body2'>{rejectionReason}</Text>
        </TimelineBlockBase>
      )}
      <TimelineBlockBase title={localizedStrings.complianceInformation}>
        <Flex alignItems='center' gap={0.75}>
          <DescriptionOutlined sx={{ color: 'primary.main', fontSize: 18 }} />
          {fileUrl ? (
            <Link href={fileUrl} target='_blank' rel='noopener noreferrer'>
              <Text variant='body2' color='primary.main' fontWeight={500}>
                {title}
              </Text>
            </Link>
          ) : (
            <Text variant='body2' fontWeight={500}>
              {title}
            </Text>
          )}
        </Flex>
      </TimelineBlockBase>
      {showApprovedDuration && (
        <TimelineBlockBase title={localizedStrings.validDuration}>
          <Flex alignItems='center' justifyContent='flex-start'>
            <Box>
              <Text>{moment(auditResult.createdOn).format('DD MMM YYYY')}</Text>
              <Text fontSize={12}>
                {moment(auditResult.createdOn).format('HH:mm')}
              </Text>
            </Box>
            <EastIcon sx={{ mx: 2, opacity: 0.5 }} />
            <Box>
              <Text>{moment(expiryDate).format('DD MMM YYYY')}</Text>
              <Text fontSize={12}>{moment(expiryDate).format('HH:mm')}</Text>
            </Box>
          </Flex>
        </TimelineBlockBase>
      )}
      {showExpiredEnd && (
        <TimelineBlockBase title={localizedStrings.validUntil}>
          <Box>
            <Text>{moment(expiryDate).format('DD MMM YYYY')}</Text>
            <Text fontSize={12}>{moment(expiryDate).format('HH:mm')}</Text>
          </Box>
        </TimelineBlockBase>
      )}
    </>
  )
}
